export default __webpack_public_path__ + "media/images/steps/step-5-6d8d646fd67b5580769ed2fec03e64d8.svg";